module.exports = __webpack_public_path__ + "img/nochoose.f71a221a.svg";